import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@shared/utils/route.utils.ts';
import GeneralInfo from './pages/general-info/general-info.tsx';
import Branding from './pages/branding/branding.tsx';
import ApiKey from './pages/api-key/api-key.tsx';

const OrganizationComponent = lazy(() => import('./organization.tsx'));

export const organizationRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <OrganizationComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.Organization.General.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.Organization.General.path,
        element: (
          <Suspense>
            <GeneralInfo />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Organization.Branding.path,
        element: (
          <Suspense>
            <Branding />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Organization.ApiKey.path,
        element: (
          <Suspense>
            <ApiKey />
          </Suspense>
        )
      }
    ]
  }
];
